import OptimizedImage from "@/components/OptimizedImage";
import React from "react";
import { useGalleryImagesForPreview } from "@/api/hooks/useGalleryImagesForPreview";

const GalleryPlaceholder = ({ className }: { className?: string }) => (
  <div
    className={`bg-[#2C2C2E] flex items-center justify-center ${className}`}
    aria-hidden
  >
    <div className="w-12 h-12 rounded-full border-2 border-[#8E8E93] border-dashed opacity-50" />
  </div>
);

const layoutConfig = [
  "md:col-span-1",
  "md:col-span-2 md:row-span-2 h-[600px]",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-1",
  "md:col-span-2 h-[600px] -mt-[200px]",
  "md:col-span-1",
];

const mobileLayoutConfig = [
  { cols: "col-span-2", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
  { cols: "col-span-1", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
  { cols: "col-span-1", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
  { cols: "col-span-1", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
  { cols: "col-span-1", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
  { cols: "col-span-2", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
  { cols: "col-span-1", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
  { cols: "col-span-1", aspectRatio: "aspect-square", rounded: "rounded-2xl" },
];

const ArtistPremiumGallery = () => {
  const { slots } = useGalleryImagesForPreview("premium");

  return (
    <>
      <div className="md:hidden p-4 w-screen">
        <div className="rounded-[32px] p-4 grid grid-cols-2 gap-2">
          {slots.map((slot, index) => (
            <div
              key={slot.type === "image" ? slot.id : `ph-${slot.index}`}
              className={`${mobileLayoutConfig[index]?.cols ?? "col-span-1"} ${mobileLayoutConfig[index]?.aspectRatio ?? "aspect-square"} relative overflow-hidden ${mobileLayoutConfig[index]?.rounded ?? "rounded-2xl"} pointer-events-none`}
            >
              {slot.type === "image" ? (
                <OptimizedImage
                  src={slot.url}
                  alt={`Image ${index + 1}`}
                  className="object-cover w-full h-full object-top"
                  fill
                  sizes="(max-width: 600px) 50vw, 25vw"
                />
              ) : (
                <GalleryPlaceholder className="w-full h-full rounded-2xl" />
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="hidden md:block w-screen">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[400px] min-h-screen my-40 p-4">
          {slots.map((slot, index) => (
            <div
              key={slot.type === "image" ? slot.id : `ph-${slot.index}`}
              className={`relative pointer-events-none overflow-hidden ${layoutConfig[index] ?? ""}`}
            >
              {slot.type === "image" ? (
                <OptimizedImage
                  src={slot.url}
                  alt={`Image ${index + 1}`}
                  className="object-cover object-top rounded-lg"
                  fill
                  sizes="(max-width: 768px) 100vw, 25vw"
                />
              ) : (
                <GalleryPlaceholder className="w-full h-full rounded-lg" />
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ArtistPremiumGallery;
